import React from 'react'
import GenericModal from '../GenericModal'
import { Box, Typography } from '@mui/material'
import { ButtonType } from '../GenericButton/styles'
import { motion } from 'framer-motion'
import { green } from '../../colors'

interface ExportProcessingModalProps {
  isOpen: boolean
  onClose: () => void
  message?: string
}

const AnimatedCheckmark: React.FC = () => (
  <Box display="flex" justifyContent="center" mt={2} mb={1}>
    <motion.div
      initial={{ scale: 0, opacity: 0 }}
      animate={{ scale: 1, opacity: 1 }}
      transition={{ type: 'spring', stiffness: 200, damping: 15, delay: 0.1 }}
    >
      <svg width="56" height="56" viewBox="0 0 56 56" fill="none">
        <motion.circle
          cx="28"
          cy="28"
          r="26"
          stroke={green[200]}
          strokeWidth="3"
          fill={green[0]}
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.5, ease: 'easeInOut' }}
        />
        <motion.path
          d="M17 28.5L24 35.5L39 20.5"
          stroke={green[200]}
          strokeWidth="3"
          strokeLinecap="round"
          strokeLinejoin="round"
          fill="none"
          initial={{ pathLength: 0 }}
          animate={{ pathLength: 1 }}
          transition={{ duration: 0.4, ease: 'easeInOut', delay: 0.3 }}
        />
      </svg>
    </motion.div>
  </Box>
)

const ExportProcessingModal: React.FC<ExportProcessingModalProps> = ({ isOpen, onClose, message }) => {
  return (
    <GenericModal
      isOpen={isOpen}
      onClose={onClose}
      title="Export is being processed"
      maxWidth="xs"
      hideConfirmButton
      destructiveButtonType={ButtonType.Primary}
      destructiveButtonText='OK'
    >
      <AnimatedCheckmark />
      <Typography mt={1} textAlign="center">
        {message || 'Your export is being processed in the background. You will receive it shortly.'}
      </Typography>
    </GenericModal>
  )
}

export default ExportProcessingModal
